import basic from './basic-field-types';
import contacts from './contacts-field-types';

export default {
  basic,
  contacts,
};
